package common.dto

import kotlinx.serialization.Serializable

/**
 * Represents an axis with an origin in 3D space.
 */
@Serializable
data class Line3d(
    val origin: Vec3d,
    val direction: Vec3d
) {
    companion object {
        val X_AXIS = Line3d(Vec3d(), Vec3d(x = 1.0))
        val Y_AXIS = Line3d(Vec3d(), Vec3d(y = 1.0))
        val Z_AXIS = Line3d(Vec3d(), Vec3d(z = 1.0))
    }
}
